import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { RazorpayTransactionRequest } from '../models/razorpay-payment-details';

@Injectable({
  providedIn: 'root'
})
export class RazorpayService {
  razorpayurl = environment.PAYMENT_UI + '/epms/razorpay';

  constructor(private http: HttpClient) { }

  httpHeaders = {
    headers:  new HttpHeaders({'Content-Type': 'application/json'})
  };

  captureRazorpayFinalResponse(orderTranscationId: string,reqBody: RazorpayTransactionRequest): Promise<string> {
    return firstValueFrom(this.http.post<string>(this.razorpayurl + '/capture/' + orderTranscationId, reqBody,
      { ...this.httpHeaders, withCredentials: true }
    ));
  }
}
